import Truckers from 'views/Truckers/Truckers.jsx';
import AddTruckers from 'views/Truckers/AddTruckers.jsx';
import Transactions from 'views/Transactions/SalesTransactions.jsx';

import AddTransactions from 'views/Transactions/AddTransactions.jsx';

import LocalShipping from '@material-ui/icons/LocalShipping';
import SwapHoriz from '@material-ui/icons/SwapHoriz';

// @material-ui/icons
import DashboardIcon from '@material-ui/icons/Dashboard';
import DashboardRedirect from '../views/Dashboard/DashboardRedirect';

const salesDashRoutes = [
  {
    path: '/sales/dashboard',
    name: 'Dashboard',
    icon: DashboardIcon,
    component: DashboardRedirect,
  },
  {
    collapse: true,
    path: '/sales/truckers',
    name: 'Truckers',
    icon: LocalShipping,
    state: 'openTruckers',
    views: [
      {
        path: '/sales/truckers/view',
        name: 'View',
        mini: 'V',
        component: Truckers,
      },
      {
        path: '/sales/truckers/add',
        name: 'Add',
        mini: 'A',
        component: AddTruckers,
      },
    ],
  },
  {
    collapse: true,
    path: '/sales/transactions',
    name: 'Transactions',
    icon: SwapHoriz,
    state: 'openTransactions',
    views: [
      {
        path: '/sales/transactions/view',
        name: 'View',
        mini: 'V',
        component: Transactions,
      },
      {
        path: '/sales/transactions/add',
        name: 'Add',
        mini: 'A',
        component: AddTransactions,
      },
    ],
  },
  {
    redirect: true,
    path: '/sales',
    pathTo: '/sales/dashboard',
    name: 'Dashboard',
  },
];

const salesManagerDashRoutes = [
  {
    path: '/sales/dashboard',
    name: 'Dashboard',
    icon: DashboardIcon,
    component: DashboardRedirect,
  },
  {
    collapse: true,
    path: '/sales/truckers',
    name: 'Truckers',
    icon: LocalShipping,
    state: 'openTruckers',
    views: [
      {
        path: '/sales/truckers/view',
        name: 'View',
        mini: 'V',
        component: Truckers,
      },
      {
        path: '/sales/truckers/add',
        name: 'Add',
        mini: 'A',
        component: AddTruckers,
      },
    ],
  },
  {
    collapse: true,
    path: '/sales/transactions',
    name: 'Transactions',
    icon: SwapHoriz,
    state: 'openTransactions',
    views: [
      {
        path: '/sales/transactions/view',
        name: 'View',
        mini: 'V',
        component: Transactions,
      },
      {
        path: '/sales/transactions/add',
        name: 'Add',
        mini: 'A',
        component: AddTransactions,
      },
    ],
  },
  {
    redirect: true,
    path: '/sales',
    pathTo: '/sales/dashboard',
    name: 'Dashboard',
  },
];

export default salesDashRoutes;

export { salesManagerDashRoutes };
